export const ShowQuerySamplingCTADelay = 3000;

export const QuerySamplingToggledTrackedEvent = `Query Sampling Toggled`;

export enum QuerySamplingToggleSource {
  QueryCTA = `query_cta`,
  ReportHeader = `report_header`,
}
